<template>
    <form class="wizard-form steps-basic wizard clearfix">
        <div class="steps clearfix">
            <ul>
                <li v-for="(step, i) in steps" :class="{ 'first': i === 0, 'current': i === activeIndex, 'done': i !== activeIndex && done[i] === true, 'disabled': isLoading }" :key="i">
                    <a @click="clickOnStep(i)">
                        <span class="number">{{ i + 1 }}</span>{{ step.name }}
                    </a>
                </li>
            </ul>
        </div>
        <div class="content clearfix">
            <div class="text-center m-3" v-if="isLoading">
                <i class="icon-spinner2 spinner mr-2"></i>
                Loading...
            </div>
            <template v-for="(step, i) in steps" :key="i">
                <h6 tabindex="-1" class="title current">{{ step.name }}</h6>
                <fieldset :class="[`body`, { current: i === activeIndex }]" :style="i !== activeIndex || isLoading ? 'display: none;' : ''">
                    <component
                        :is="step.component"
                        v-bind="step.props"
                        :ref="el => setStepRef(el, i)"
                        @update:isReadyForNext="(val) => {if (i === activeIndex) isReadyForNext = val}"
                    />
                </fieldset>
            </template>
        </div>
        <div class="actions clearfix">
            <ul>
                <li :class="{ 'disabled': activeIndex === 0 || isLoading }">
                    <a href="#previous" :class="['btn', 'btn-light', { 'disabled': activeIndex === 0 || isLoading }]" @click="clickPrevious">
                        <i class="icon-arrow-left13 mr-2"></i> {{ $t('wizardForm.previous') }}
                    </a>
                </li>
                <li :class="{ 'disabled': activeIndex === steps.length - 1 || !isReadyForNext }" :style="{display: activeIndex < steps.length - 1 ? '' : 'none'}">
                    <a href="#next" :class="['btn', 'btn-primary', { 'disabled': activeIndex === steps.length - 1 || !isReadyForNext }]" @click="clickNext"> {{ $t('wizardForm.next') }} 
                        <i class="icon-arrow-right14 ml-2"></i>
                    </a>
                </li>
                <li :class="{ 'disabled': !isReadyForNext || isLoading }" :style="{ display: activeIndex === steps.length - 1 ? '' : 'none' }" @click="clickSubmit">
                    <a href="#finish" :class="['btn', 'btn-primary', { 'disabled': !isReadyForNext || isLoading }]"> {{ $t('wizardForm.submit') }}
                        <i class="icon-arrow-right14 ml-2"></i>
                    </a>
                </li>
            </ul>
        </div>
    </form>
</template>
<script>
export default {
    name: "WizardForm",
    emits: ['submit', 'click-next'],
    props: {
        steps: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            activeIndex: 0,
            done: [],
            stepRefs: [],
            isReadyForNext: false,
            isLoading: false
        }
    },
    methods: {
        setStepRef(el, index) {
            if (el) {
                this.stepRefs[index] = el;
            }
        },
        clickNext() {
            this.done[this.activeIndex] = true;
            if (this.activeIndex < this.steps.length - 1) {
                this.activeIndex++;
                this.refreshIsReadyForNext();
                this.$emit('click-next');
            }
        },
        clickPrevious() {
            if (this.activeIndex > 0) {
                this.activeIndex--;
                this.refreshIsReadyForNext();
            }
        },
        clickSubmit() {
            if (!this.isReadyForNext) {
                return;
            }
            
            this.isLoading = true;
            this.$emit('submit');
        },
        clickOnStep(index) {
            if (this.isLoading) return;

            if (this.done[index]) {
                this.activeIndex = index;
                this.refreshIsReadyForNext();
            }
        },
        refreshIsReadyForNext() {
            const currentStepComponent = this.stepRefs[this.activeIndex];

            if (currentStepComponent && typeof currentStepComponent.isReadyForNext === 'boolean') {
                this.isReadyForNext = currentStepComponent.isReadyForNext;
                return;
            }

            this.isReadyForNext = true;
        }
    }
}
</script>